module.exports = __webpack_public_path__ + "static/media/content.c2086922.svg";